import React from 'react';
import PropTypes from 'prop-types';
import { Div, Tag } from '@pinpoint/design-kit';

import { withFixedTitle } from 'src/components';

export function Suggestions({ list }) {
	return (
		<Div>
			<Div m={{ x: '0.7rem' }}>
				{list.map((item) => (
					<Tag textColor="white" bg="brand500" m={{ l: '0.3rem', r: '0.3rem', b: '0.3rem' }}>
						{item.replace(/,/g, '').replace(/\./g, '')}
					</Tag>
				))}
			</Div>
		</Div>
	);
}

Suggestions.propTypes = {
	list: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default withFixedTitle(Suggestions);
